import { render } from "./CheckoutComponent.vue?vue&type=template&id=8f3afb60"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/checkout/CheckoutComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f3afb60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f3afb60', __exports__)) {
    api.reload('8f3afb60', __exports__)
  }
  
  module.hot.accept("./CheckoutComponent.vue?vue&type=template&id=8f3afb60", () => {
    api.rerender('8f3afb60', render)
  })

}


export default __exports__